import type { SVGProps } from "react";
export interface BowTieIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BowTieIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BowTieIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 12c0-1.116.242-3.294 1.027-4.913.389-.802 1.012-1.676 2.01-2.043 1.071-.395 2.199-.08 3.272.698l3.333 2.416.09.073a1.125 1.125 0 0 1-1.314 1.812l-.096-.063-3.333-2.416c-.724-.524-1.06-.45-1.175-.408-.187.069-.47.31-.763.912-.578 1.192-.801 2.99-.801 3.932s.223 2.74.801 3.932c.293.603.576.843.763.912.114.042.452.116 1.175-.408l3.333-2.416.096-.063a1.124 1.124 0 0 1 1.224 1.884l-3.333 2.417c-1.073.778-2.2 1.092-3.272.697-.998-.367-1.621-1.24-2.01-2.042C1.117 15.294.875 13.116.875 12m20 0c0-.942-.222-2.74-.8-3.932-.293-.603-.576-.843-.764-.912-.099-.037-.37-.098-.92.239l-.254.17-3.334 2.415-.66-.911-.66-.91 3.332-2.417.405-.27c.95-.576 1.931-.772 2.87-.427.997.368 1.62 1.24 2.01 2.042.784 1.619 1.024 3.798 1.024 4.913s-.24 3.294-1.025 4.913c-.389.802-1.012 1.676-2.01 2.044-1.072.394-2.2.079-3.274-.7l-3.332-2.415.66-.91.66-.912 3.334 2.416c.724.525 1.061.45 1.174.408.188-.069.471-.31.764-.912.578-1.192.8-2.99.8-3.932m-7.643 2.27a1.124 1.124 0 0 1 1.57-.25l-1.32 1.822a1.126 1.126 0 0 1-.25-1.571Zm1.57-4.29a1.124 1.124 0 1 1-1.32-1.82z"
      />
      <path
        fill={color}
        d="M12.969 7.375c1.257 0 2.078.84 2.524 1.704.278.54.457 1.161.55 1.795H17.5l.115.006a1.125 1.125 0 0 1 0 2.239l-.115.005h-1.456c-.095.635-.273 1.257-.551 1.798-.446.864-1.267 1.703-2.524 1.703H11.03c-1.257 0-2.077-.84-2.523-1.703-.278-.54-.456-1.163-.55-1.798H6.5a1.125 1.125 0 0 1 0-2.25h1.458c.094-.634.272-1.255.55-1.795.446-.864 1.266-1.704 2.523-1.704zm-1.938 2.25c-.097 0-.292.036-.523.485-.233.452-.382 1.137-.382 1.89s.148 1.438.382 1.89c.231.449.426.486.523.486h1.938c.096 0 .293-.037.524-.485.234-.453.383-1.139.383-1.892s-.15-1.437-.383-1.89c-.231-.448-.428-.484-.524-.484H11.03Z"
      />
    </svg>
  );
}
